import {RemoveCommand} from "../../../commands/RemoveCommand";
import {CreateWidgetFromFirebaseNode} from "../lib/vue-dom-obj";
import _ from "lodash";
import {BulkPropertyChangeCommand} from "../../../commands/BulkPropertyChangeCommand";
import {DuplicateCommand} from "../../../commands/DuplicateCommand";
import {mapGetters, mapMutations} from "vuex";
import * as getters from "../../../store/modules/getters";
import * as mutations from "../../../store/modules/mutations";


export default {
    computed: {
        ...mapGetters({
            site: getters.SITE_GET_DATA,
            thankYouPage: getters.SITE_GET_THANKYOU,
        })
    },
    methods: {
        ...mapMutations({
            disableCommandPush: mutations.HISTORY_IGNORE,
            enableCommandPush: mutations.HISTORY_LISTEN,
        }),
        setPageId (vNode) {
            const pageId = _.get(vNode, 'data.props.pageId', '')
            if (pageId === '') {
                console.log("this.site: ", this.site)
                if (this.site.pages.length > 2) {
                    const thankYou = _.find(this.site.pages, (page) => {
                        return page.name.includes('thank you')
                    })
                    if (thankYou) {
                        _.set(vNode, 'data.props.pageId', thankYou.id)
                    } else {
                        console.debug('Can\'t link automatically to the thank you page.')
                    }
                } else if (this.site.pages.length === 2) {
                    console.debug('Able to connect thank you page.')
                    _.set(vNode, 'data.props.pageId', this.thankYouPage.id)
                }
            }
        },
        forceRemoveNode (component) {
            this.getGrid().removeWidget(component.$el)
            this.fbNode.children = this.fbNode.children.filter(
                x => x.data.props.vnodeId !== component.vnodeId
            )
            // save to database
            this.firebaseRef.removeNode(+component.idx())
        },
        removeNode (component) {
            this.pushCommand(new RemoveCommand(this, component))
        },
        duplicateNode (node) {
            let clonedNode = CreateWidgetFromFirebaseNode({
                data: Object.assign({}, node.data),
                tag: node.tag,
                desktop: Object.assign({}, node.desktop),
                phone: Object.assign({}, node.phone),
                children: node.children.map(x => _.clone(x))
            }, true)
            clonedNode[this.viewMode].dataY =  clonedNode.data.props[this.viewMode].dataY += (2 + clonedNode.data.props[this.viewMode].dataHeight)
            this.pushCommand(new DuplicateCommand(this, clonedNode, this.viewMode))
        },
        makeWidget(element) {
            let _element = element
            if (_element.$el !== undefined) {
                _element = _element.$el
            }
            this.getGrid().makeWidget(_element);
            return element
        },
        change: _.debounce(function (e, items) {
            const bulkChangeCommand = new BulkPropertyChangeCommand(this)
            if (items.length > 0) {
                items.forEach((changedItem) => {
                    const vNodeID = changedItem.el.dataset.vnodeId || 0
                    this.$children.forEach((child) => {
                        if (child.vnodeId === vNodeID) {
                            let command = child.createCommand(
                                this.viewMode,
                                {
                                    dataX: changedItem.x,
                                    dataY: changedItem.y,
                                    dataWidth: changedItem.w,
                                    dataHeight: changedItem.h,
                                }
                            )
                            bulkChangeCommand.addCommand(command)

                            if (
                                child.$children.length > 0 &&
                                child.$children[0].name === 'Icon'
                            ) {
                                const remValue = Math.floor(
                                    (child.$el.offsetWidth * 1) / 12.48
                                )
                                command = child.$children[0].createCommand('size', remValue)
                                bulkChangeCommand.addCommand(command)
                            }
                            if (['Draft', 'DraftV3'].includes(child.$children[0].name)) {
                                setTimeout(() => {
                                    child.triggerResizeChild()
                                }, 0)
                            }
                        }
                    })
                })
            }
            this.validateAndPushCommand(bulkChangeCommand)
        }, 500),
        resize () {
            if (this.isGridBuilder && !['GridItemWrapper', 'GridItemWrapperV3'].includes(this.parent().name)) {
                return
            }

            const gridItem = this.parent()
            const gridContainer = this.parent().parent()

            this.$nextTick(() => {
                const ofHeight = Math.max(this.$el.offsetHeight, ...Array(...this.$el.children).map(a => a.offsetHeight))
                const height = Math.round(
                    (ofHeight + (gridContainer.getGrid().opts.verticalMargin || 0)) / ((gridContainer.getGrid().getCellHeight() + (gridContainer.getGrid().opts.verticalMargin || 0)) || 1)
                )
                if (!gridContainer.itemResizing) {
                    gridContainer.getGrid().update(
                        gridItem.$el, {w: gridItem.dataWidth, h: Math.max(height, gridItem.dataHeight)}
                    )
                }
            })
        },
    }
}